import {
  STEP_ABOUT_LOGO,
  STEP_SECTOR,
  STEP_VALUES,
  STEP_EMOTIONS,
  // STEP_VISUAL_INSPIRATION, STEP_COLOR_PALETTES, STEP_TYPEFACES,
  STEP_TYPE,
  STEP_KEYWORDS,
  STEP_LOGO_PREVIEWS,
  STEP_LOGO_DOWNLOAD,

  // STEP_TYPEFACES_SUCCESS,

  UPDATE_LOGO_NAME,
  UPDATE_SLOGAN,
  UPDATE_LOGO_DESCRIPTION,
  UPDATE_SELECTED_SECTOR,
  UPDATE_SELECTED_VALUES,
  UPDATE_SELECTED_EMOTIONS,
  UPDATE_SELECTED_KEYWORDS,
  UPDATE_SELECTED_TYPE,
  // UPDATE_SELECTED_IMAGES,
  // UPDATE_SELECTED_COLOR_PALETTES,
  // UPDATE_SELECTED_TYPEFACES,
  UPDATE_SELECTED_LOGO_PREVIEWS,
  GET_NEXT_LOGO_PREVIEW,
  GET_PREVIOUS_LOGO_PREVIEW,
  UPDATE_LOGO_CANVAS,

  UPDATE_SELECTED_LANGUAGE,

  FETCH_SECTOR_SUCCESS,
  FETCH_VALUES_SUCCESS,
  FETCH_EMOTIONS_SUCCESS,
  FETCH_ICONS,
  FETCH_ICONS_SUCCESS,
  FETCH_ICONS_FAILURE,
  // FETCH_IMAGES_SUCCESS,
  // FETCH_COLOR_PALETTES_SUCCESS,
  // FETCH_TYPEFACES_SUCCESS,
  FETCH_LOGO_PREVIEWS,
  FETCH_LOGO_PREVIEWS_SUCCESS,
  FETCH_LOGO_PREVIEWS_FAILURE,

  KEY_LEFT, KEY_RIGHT
} from '../actions/new-logo'
import { contrastColors, randomizePalette } from '../colorProcedures'

const MAX_STEPS = 8

const shuffle = (array) => {
  // from https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array#2450976
  let currentIndex = array.length, temporaryValue, randomIndex
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1
    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }
  return array
}

const INITIAL_STATE = {
  currentStep: 1,
  step: {
    error: null,
    loading: false
  },
  userPrefs: {
    logoName: "",
    logoDescription: "",
    selectedSector: [],
    selectedValues: [],
    selectedEmotions: [],
    selectedImages: [],
    selectedColorPalettes: [],
    selectedTypefaces: [],
    selectedType: '',
    selectedLogoPreviews: null,
    selectedLanguage: 'en',
    selectedKeywords: ['', '', ''],
    updatedPrefs: {
      typefaces: false,
      colors: false,
      logos: false,
      sector: false,
      values: false,
      emotions: false,
      language: false,
      name: false,
      keywords: false,
      type: false
    }

  },
  currentLogoPreview: 0
}

const users = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    // About Step

    case STEP_ABOUT_LOGO:
      return { ...state,
        currentStep: 1
      }

    case UPDATE_LOGO_NAME:
      let { logoName } = action.payload
      return {
        ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          logoName: logoName,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            name: true
          }
        })
      }

    case UPDATE_SLOGAN:
      let { brandSlogan } = action.payload
      return {
        ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          brandSlogan: brandSlogan,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            name: true
          }
        })
      }

    case UPDATE_LOGO_DESCRIPTION:
      let { logoDescription } = action.payload
      return { ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          logoDescription: logoDescription,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            name: true
          }
        })
      }

    // Brand Sector Step

    case STEP_SECTOR:
      return {
        ...state,
        currentStep: 2
      }

    case UPDATE_SELECTED_SECTOR:
      let { selectedSector } = action.payload
      return { ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          selectedSector: selectedSector,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            sector: true
          }
        })
      }

    case FETCH_SECTOR_SUCCESS:
      return {
        ...state,
        availableSector: action.payload
      }

    // Brand Values Step

    case STEP_VALUES:
      return { ...state,
        currentStep: 3
      }

    case UPDATE_SELECTED_VALUES:
      let { selectedValues } = action.payload
      return { ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          selectedValues: selectedValues,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            values: true
          }
        })
      }

    case FETCH_VALUES_SUCCESS:
      return { ...state,
        availableValues: action.payload
      }

    // Emotions Values Step

    case STEP_EMOTIONS:
      return { ...state,
        currentStep: 4
      }

    case UPDATE_SELECTED_EMOTIONS:
      let { selectedEmotions } = action.payload
      return { ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          selectedEmotions: selectedEmotions,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            emotions: true
          }
        })
      }

    case FETCH_EMOTIONS_SUCCESS:
      return { ...state,
        availableEmotions: action.payload
      }

    // // Visual Inspiration Step
    //
    // case STEP_VISUAL_INSPIRATION:
    //   return { ...state,
    //     // currentStep: 3
    //   }
    //
    // case UPDATE_SELECTED_IMAGES:
    //   let { selectedImages } = action.payload
    //   return { ...state,
    //     userPrefs: Object.assign({}, state.userPrefs, {
    //       selectedImages: selectedImages,
    //       updatedPrefs: {
    //         ...state.userPrefs.updatedPrefs,
    //         images: true
    //       }
    //     })
    //   }
    //
    // case FETCH_IMAGES_SUCCESS:
    //   return { ...state,
    //     availableImages: action.payload
    //   }

    // // Color Palettes Step
    //
    // case STEP_COLOR_PALETTES:
    //   return { ...state,
    //     // currentStep: 4
    //   }
    //
    // case UPDATE_SELECTED_COLOR_PALETTES:
    //   let { selectedColorPalettes } = action.payload
    //   return { ...state,
    //     userPrefs: Object.assign({}, state.userPrefs, {
    //       selectedColorPalettes: selectedColorPalettes,
    //       updatedPrefs: {
    //         ...state.userPrefs.updatedPrefs,
    //         colors: true
    //       }
    //     })
    //   }
    //
    // case FETCH_COLOR_PALETTES_SUCCESS:
    //   return { ...state,
    //     availableColorPalettes: action.payload
    //   }

    // Typefaces Step
    // case STEP_TYPEFACES:
    //   return { ...state,
    //     // currentStep: 5,
    //     step: {
    //       error: null,
    //       loading: true
    //     }
    //   }
    //
    // case STEP_TYPEFACES_SUCCESS:
    //   return { ...state,
    //     currentStep: 5,
    //     step: {
    //       error: null,
    //       loading: false
    //     }
    //   }
    //
    //
    // case UPDATE_SELECTED_TYPEFACES:
    //   let { selectedTypefaces } = action.payload
    //   return { ...state,
    //     userPrefs: Object.assign({}, state.userPrefs, {
    //       selectedTypefaces: selectedTypefaces,
    //       updatedPrefs: {
    //         ...state.userPrefs.updatedPrefs,
    //         typefaces: true
    //       }
    //     }),
    //   }
    //
    // case FETCH_TYPEFACES_SUCCESS:
    //   return { ...state,
    //     availableTypefaces: action.payload
    //   }

    // Type Step
    case STEP_TYPE:
      return {
        ...state,
        currentStep: 5
      }

    case UPDATE_SELECTED_TYPE:
      let { selectedType } = action.payload
      return { ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          selectedType: selectedType,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            type: true
          }
        })
      }

    // Keywords Step
    case STEP_KEYWORDS:
      return {
        ...state,
        currentStep: 6
      }

    case UPDATE_SELECTED_KEYWORDS:
      let { selectedKeywords } = action.payload
      return { ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          selectedKeywords: selectedKeywords,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            keywords: true
          }
        })
      }

    case FETCH_ICONS:
      return {
        ...state,
        availableIcons: {
          ...state.availableIcons,
          loading: true,
          error: null
        }
      }

    case FETCH_ICONS_SUCCESS:
      if (action.payload.length) {

        let _availableIcons = []
        for (let indexKey = 0; indexKey < action.payload.length; indexKey++) {
          if (action.payload[indexKey].icons) {
            _availableIcons = _availableIcons.concat(action.payload[indexKey].icons)
          }
          else if (action.payload[indexKey].recent_uploads) {
            _availableIcons = _availableIcons.concat(action.payload[indexKey].recent_uploads)
          }
        }
        if (state.availableIcons) {
          if (state.availableIcons.payload) {
            _availableIcons = _availableIcons.concat(state.availableIcons.payload)
          }
        }
        _availableIcons = shuffle(_availableIcons)

        return {
          ...state,
          availableIcons: {
            payload: _availableIcons,
            loading: false,
            error: null
          }
        }
      }
      else return state

    case FETCH_ICONS_FAILURE:
      return {
        ...state,
        availableIcons: {
          payload: null,
          loading: false,
          error: action.payload
        }
      }

    // Logo Preview Step

    case STEP_LOGO_PREVIEWS:
      return { ...state,
        currentStep: 7
      }

    case UPDATE_SELECTED_LOGO_PREVIEWS:
      let { selectedLogoPreviews, selectedLogoImage, selectedLogoCanvas, selectedLogoImageDark } = action.payload

      return { ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          selectedLogoPreviews: selectedLogoPreviews,
          selectedLogoImage: selectedLogoImage,
          selectedLogoCanvas: selectedLogoCanvas,
          selectedLogoImageDark: selectedLogoImageDark,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            logos: true
          }
        })
      }

    case UPDATE_LOGO_CANVAS:
      let { id, rawSVG, rawSVGDark, canvas, canvasDark, logoParams } = action.payload
      let previews = state.availableLogoPreviews.payload.slice(0)
      let index = id
      if (index < 0) return state
      previews[index].svg = rawSVG
      previews[index].svgDark = rawSVGDark
      previews[index].canvas = canvas
      previews[index].canvasDark = canvasDark
      if (logoParams) {
        if (logoParams.colorPalette) previews[index].colorPalette = logoParams.colorPalette
        if (logoParams.brandTypeface) previews[index].brandTypeface = logoParams.brandTypeface
        if (logoParams.sloganTypeface) previews[index].sloganTypeface = logoParams.sloganTypeface
        if (logoParams.asset) previews[index].asset = logoParams.asset
        if (logoParams.params) previews[index].layoutProcedure.params = logoParams.params
      }

      return {
        ...state,
        availableLogoPreviews: {
          ...state.availableLogoPreviews,
          payload: previews
        }
      }

    case FETCH_LOGO_PREVIEWS:
      return { ...state,
        availableLogoPreviews: {
          ...state.availableLogoPreviews,
          loading: true,
          error: null
        }
      }

    case FETCH_LOGO_PREVIEWS_SUCCESS:
      let notLoadingState = {
        ...state,
        availableLogoPreviews: {
          ...state.availableLogoPreviews,
          loading: false,
          error: null
        }
      }
      if (!action.payload) return notLoadingState
      if (!action.payload.logoPreviews ||
          !action.payload.colors ||
          !action.payload.typefaces) {
        return notLoadingState
      }
      if (action.payload.logoPreviews.length < 1) return notLoadingState

      let availableColors = []
      if (action.payload.colors.length > 0) {
        availableColors = action.payload.colors

        let randPalette, newPalette, newPaletteDark, colorBackground, newPaletteColor
        for (let i = 0; i < availableColors.length; i++) {
          // choose a color background
          colorBackground = Object.values(availableColors[i].colors).concat('#fff').concat('#000')
          colorBackground = colorBackground[Math.floor(Math.random() * colorBackground.length)]

          // Randomize original palette a bit
          randPalette = randomizePalette(Object.values(availableColors[i].colors))
          // Calculate colors from palette presenting most
          // contrast when compared with white
          newPalette = contrastColors('#ffffff', randPalette)
          newPaletteDark = contrastColors('#000000', randPalette)
          newPaletteColor = contrastColors(colorBackground, randPalette)
          availableColors[i].light = newPalette.contrasts
          availableColors[i].colored = newPaletteColor.contrasts
          availableColors[i].colorBackground = colorBackground
          availableColors[i].dark = newPaletteDark.contrasts
        }
      }
      else availableColors = state.availableColorPalettes

      let availableTypes = []
      if (action.payload.typefaces.length > 0) availableTypes = action.payload.typefaces
      else availableTypes = state.availableTypefaces

      let updatedLogos = false
      let logoPreviews = action.payload.logoPreviews
      let newPayloadPreviews = []
      let currentLogoPreviewPos = state.currentLogoPreview
      // Copy the old logos to the new array
      if (state.availableLogoPreviews.payload) {
        newPayloadPreviews = state.availableLogoPreviews.payload.slice(0)
      }
      // Copy the new logos to the new array
      for (let i = 0; i < logoPreviews.length; i++) {
        newPayloadPreviews.push(logoPreviews[i])
        updatedLogos = true
      }
      // Point to the first new logo
      if (state.availableLogoPreviews.payload) {
        if (logoPreviews.length > 1) {
          if (newPayloadPreviews[state.availableLogoPreviews.payload.length]) {
            currentLogoPreviewPos = state.availableLogoPreviews.payload.length
          }
        }
      }

      return {
        ...state,
        availableColorPalettes: availableColors,
        availableTypefaces: availableTypes,
        availableLogoPreviews: {
          payload: newPayloadPreviews,
          loading: false,
          error: null
        },
        currentLogoPreview: currentLogoPreviewPos,
        userPrefs: {
          ...state.userPrefs,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            typefaces: false,
            colors: false,
            logos: updatedLogos,
            values: false,
            emotions: false,
            language: false,
            name: false,
            keywords: false,
            type: false
          }
        }
      }

    case FETCH_LOGO_PREVIEWS_FAILURE:
      return { ...state,
        availableLogoPreviews: {
          payload: null,
          loading: false,
          error: action.payload
        }
      }

    // Logo Download Step

    case STEP_LOGO_DOWNLOAD:
      return { ...state,
        currentStep: 8
      }

    // Change language

    case UPDATE_SELECTED_LANGUAGE:
      let selectedLanguage = action.payload
      return { ...state,
        userPrefs: Object.assign({}, state.userPrefs, {
          selectedLanguage: selectedLanguage,
          updatedPrefs: {
            ...state.userPrefs.updatedPrefs,
            language: true
          }
        })
      }

    // Logo preview navigation

    case GET_NEXT_LOGO_PREVIEW:
      return { ...state,
        currentLogoPreview: state.currentLogoPreview + 1
      }

    case GET_PREVIOUS_LOGO_PREVIEW:
      return { ...state,
        currentLogoPreview: state.currentLogoPreview - 1
      }

    // Keyboard events

    case KEY_LEFT:
      // If on Preview Step, change keyboard behaviour to swipe between logo
      // previews
      if (Number(state.currentStep) === 7) {
        if (state.currentLogoPreview > 0)
          return { ...state,
            currentLogoPreview: state.currentLogoPreview - 1
          }
        return { ...state }
      }
      // Otherwise, swipe between steps
      if (Number(state.currentStep) <= 1) return { ...state }
      return { ...state,
        currentStep: state.currentStep - 1
      }

    case KEY_RIGHT:
      if (state.availableLogoPreviews) {
        if (Number(state.currentStep) === 7 && state.availableLogoPreviews.payload) {
          let numLogoPreviews = state.availableLogoPreviews.payload.length
          if (state.currentLogoPreview < numLogoPreviews-1)
            return { ...state,
              currentLogoPreview: state.currentLogoPreview + 1
            }
          return { ...state }
        }
      }
      if (Number(state.currentStep) >= MAX_STEPS ||
        state.currentStep === 5)
        return { ...state }
      return {
        ...state,
        currentStep: state.currentStep + 1
      }

    default:
      return state
  }
}

export default users



// WEBPACK FOOTER //
// ./src/reducers/NewLogo.js